import { useState } from "react";
import { NavLink } from "react-router-dom";
import { React, Link } from "../../../Headers";
import "../../../js/headerDropdown";
import {
  AUTHOR_FORM_LINK,
  CATALOGUE_LINK,
  SPECIMEN_FORM_LINK,
  ORDER_FORM_LINK,
} from "../../../constant/constant";

const AppHeader = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [showSubLinks, setShowSubLinks] = useState(false);

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
    setShowSubLinks(false);
  };

  const toggleSubLinks = () => {
    setShowSubLinks(!showSubLinks);
  };
  return (
    <>
      <nav className="navbar navbar-expand-lg sort_01">
        <Link className="navbar-brand" to="/home">
          <img src={"../../uploads/logo-white-text.png"} />
        </Link>
        <button
          className="navbar-toggler bar-icon"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          onClick={() => {
            setCollapsed(!collapsed);
            setShowSubLinks(false);
          }}
          aria-label="Toggle navigation"
        >
          {/* <span className="navbar-toggler-icon"></span> */}
          <i className="fa-solid fa-bars"></i>
        </button>

        <div
          className={`collapse navbar-collapse ${collapsed ? "" : "show"}`}
          id="navbarSupportedContent"
          style={{ justifyContent: "end" }}
        >
          <ul className="navbar-nav">
            <li className="nav-item d-flex align-items-center">
              <NavLink
                className="nav-link sort-nav-menu"
                activeClassName="sort-nav-active-menu"
                onClick={() => {
                  setCollapsed(true);
                  setShowSubLinks(false);
                }}
                to="/home"
              >
                Home <span className="sr-only">(current)</span>
              </NavLink>
            </li>
            {/* <li className="nav-item dropdown">
              <a
                className="nav-link sort-nav-menu dropdown-toggle"
                href="#"
                data-bs-toggle="dropdown"
              >
                Home
              </a>
              <ul className="dropdown-menu">
                <li>
                  <NavLink className="dropdown-item" to="/journalhome/home">
                    Journal
                  </NavLink>
                </li>
              </ul>
            </li> */}
            <li className="nav-item d-flex align-items-center">
              <NavLink
                className="nav-link sort-nav-menu"
                activeClassName="nav-link sort-nav-active-menu"
                to="/our_vision"
                onClick={toggleNavbar}
              >
                Our Vision
              </NavLink>
            </li>
            <li className="nav-item d-flex align-items-center">
              <NavLink
                className="nav-link sort-nav-menu"
                activeClassName="nav-link sort-nav-active-menu"
                to="/author_and_reviewer"
                onClick={toggleNavbar}
              >
                Authors and Reviewers{" "}
              </NavLink>
            </li>
            <li className="nav-item d-flex align-items-center">
              <NavLink
                className="nav-link sort-nav-menu"
                activeClassName="nav-link sort-nav-active-menu"
                to="/peer_review_process"
                onClick={toggleNavbar}
              >
                Peer Review Process{" "}
              </NavLink>
            </li>
            {/* <li className="nav-item d-flex align-items-center">
        <NavLink className="nav-link sort-nav-menu" activeClassName="nav-link sort-nav-active-menu" to="/sortsubscription">Subscription</NavLink>
      </li> */}
            {/* <li className="nav-item d-flex align-items-center">
              <NavLink
                className="nav-link sort-nav-menu"
                activeClassName="nav-link sort-nav-active-menu"
                to="/technology"
                onClick={toggleNavbar}
              >
                Technology
              </NavLink>
            </li> */}

            <li className="nav-item d-flex align-items-center">
              <NavLink
                className="nav-link sort-nav-menu"
                activeClassName="nav-link sort-nav-active-menu"
                to="/book"
                onClick={toggleNavbar}
              >
                Books
              </NavLink>
            </li>

            <li className={`nav-item dropdown ${showSubLinks ? "show" : ""}`}>
              <div className="d-flex align-items-center">
                <a
                  className="nav-link sort-nav-menu dropdown-toggle"
                  href="#"
                  id="formsDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  data-toggle="dropdown"
                  aria-expanded={showSubLinks ? "true" : "false"}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleSubLinks();
                  }}
                >
                  Forms
                </a>
              </div>
              <ul
                className={`dropdown-menu ${showSubLinks ? "show" : ""}`}
                aria-labelledby="formsDropdown"
              >
                <li>
                  <NavLink
                    className="dropdown-item"
                    to={{ pathname: AUTHOR_FORM_LINK }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(AUTHOR_FORM_LINK, "_blank");
                      setCollapsed(true);
                      setShowSubLinks(false);
                    }}
                    target="_blank"
                  >
                    Be an author
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="dropdown-item"
                    to={{ pathname: SPECIMEN_FORM_LINK }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(SPECIMEN_FORM_LINK, "_blank");
                      setCollapsed(true);
                      setShowSubLinks(false);
                    }}
                    target="_blank"
                  >
                    Specimen form
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="dropdown-item"
                    to={{ pathname: CATALOGUE_LINK }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(CATALOGUE_LINK, "_blank");
                      setCollapsed(true);
                      setShowSubLinks(false);
                    }}
                    target="_blank"
                  >
                    Catalogue
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="dropdown-item"
                    to="/orderdetails"
                    onClick={() => {
                      setCollapsed(true);
                      setShowSubLinks(false);
                    }}
                  >
                    Order form
                  </NavLink>
                </li>
              </ul>
            </li>

            <li className="nav-item d-flex align-items-center">
              {/* <NavLink
                className="nav-link sort-nav-menu"
                activeClassName="nav-link sort-nav-active-menu"
                to="/sortmanuscript"
                onClick={toggleNavbar}
              >
                Submit Manuscript
              </NavLink> */}
              <NavLink
                className="nav-link sort-nav-menu"
                activeClassName="nav-link sort-nav-active-menu"
                to="/login"
                onClick={toggleNavbar}
                target="_blank"
              >
                Login
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default AppHeader;
